import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { SlateKitContext } from '../hooks';
export const SlateKitProvider = ({ kit, context: initialContext, children, }) => {
    const [activeBlocks, setActiveBlocks] = useState([]);
    const [selectedBlocks, setSelectedBlocks] = useState([]);
    const [slateUpdates, setSlateUpdates] = useState({});
    const [mode, setMode] = useState('live');
    const updateSlateById = (slateId, slateChanges) => {
        setSlateUpdates(slateUpdates => (Object.assign(Object.assign({}, slateUpdates), { [slateId]: slateChanges })));
    };
    const revertSlateUpdatesById = (slateId) => {
        setSlateUpdates(slateUpdates => (Object.assign(Object.assign({}, slateUpdates), { [slateId]: undefined })));
    };
    const updateActiveBlock = (updateBlock) => {
        setActiveBlocks(activeBlocks => {
            if (updateBlock === null || updateBlock === void 0 ? void 0 : updateBlock.id)
                return [updateBlock];
            if (activeBlocks[0] && updateBlock)
                return [Object.assign(Object.assign({}, activeBlocks[0]), updateBlock)];
            return [];
        });
    };
    const pushActiveBlock = (block) => {
        setActiveBlocks(activeBlocks => {
            return [...activeBlocks, block];
        });
    };
    const popActiveBlock = () => {
        setActiveBlocks(activeBlocks => {
            return activeBlocks.length > 0 ? activeBlocks.slice(0, -1) : [];
        });
    };
    const selectBlock = (selectedBlock) => {
        setSelectedBlocks(blocks => {
            return [
                ...blocks.filter(block => block.id !== selectedBlock.id ||
                    block.level !== selectedBlock.level),
                selectedBlock,
            ].sort((a, b) => b.level - a.level);
        });
    };
    const unselectBlock = (selectedBlock) => {
        setSelectedBlocks(blocks => {
            return blocks
                .filter(block => block.id !== selectedBlock.id ||
                block.level !== selectedBlock.level)
                .sort((a, b) => b.level - a.level);
        });
    };
    return (_jsx(SlateKitContext.Provider, Object.assign({ value: {
            kit,
            mode,
            context: Object.assign(Object.assign({}, initialContext), { activeBlock: activeBlocks.length > 0
                    ? activeBlocks[activeBlocks.length - 1]
                    : null, activeBlocks,
                selectedBlocks,
                slateUpdates }),
            setMode,
            updateActiveBlock,
            setActiveBlocks,
            pushActiveBlock,
            popActiveBlock,
            selectBlock,
            unselectBlock,
            updateSlateById,
            revertSlateUpdatesById,
            setSlateUpdates,
        } }, { children: children }), void 0));
};
//# sourceMappingURL=SlateKitProvider.component.js.map